import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { EntityType } from 'common/enums';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';
import { IndicatorDTO } from 'common/models/data/indicator.model';
import { PagedRequest } from 'common/models/data/pagedRequest.model';
import { SearchDTO } from 'common/models';

const previewDataConfig = {
    getCategoriesUrl: (pagedRequest: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORIES}`,
            ApiMethods.POST,
            '',
            pagedRequest
        ),
    getAllEntitiesUrl: (pagedRequest: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.ALL_ENTITIES}`,
            ApiMethods.POST,
            '',
            pagedRequest
        ),
    getEntitiesUrl: (categoryId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.ENTITY_DETAILS}/${categoryId}`,
            ApiMethods.GET
        ),
    getErrorCountUrl: (): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.ERROR_COUNT}`,
            ApiMethods.GET
        ),
    getIndicatorUrl: (indicatorId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.INDICATOR}/${indicatorId}`,
            ApiMethods.GET
        ),
    deleteIndicatorUrl: (indicatorId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.INDICATOR}/${indicatorId}`,
            ApiMethods.POST
        ),
    updateIndicatorUrl: (indicatorId: string, data: IndicatorDTO): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.INDICATOR}/${indicatorId}`,
            ApiMethods.PUT,
            '',
            data
        ),
    getCategoriesErrorUrl: (pagedRequest: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORY_ERROR_DETAILS}`,
            ApiMethods.POST,
            '',
            pagedRequest
        ),
    getCategoriesErrorByEntityUrl: (categoryId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.ERROR_DETAILS}/${categoryId}`,
            ApiMethods.GET
        ),
    getErrorDetailsUrl: (categoryId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.ERROR_DETAILS}/${categoryId}`,
            ApiMethods.GET
        ),
    deleteCategoryUrl: (categoryId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORY}/${categoryId}`,
            ApiMethods.POST
        ),
    updateCategoryUrl: (categoryId: string, data: any): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORY}/${categoryId}`,
            ApiMethods.PUT,
            '',
            data
        ),
    getEntityDetailsUrl: (categoryId: string, entityType: EntityType): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORY_DETAILS}/${categoryId}`,
            ApiMethods.GET,
            `entityType=${entityType}`
        ),
    getSearchUrl: (data: SearchDTO): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.SEARCH}`,
            ApiMethods.POST,
            ``,
            data
        ),
    getEntityPathUrl: (categoryId: string): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.GET_ENTITY_PATH}/${categoryId}`,
            ApiMethods.GET
        )
};

export default previewDataConfig;
